import { c as _c } from "react/compiler-runtime";
import { BodyLong } from "@navikt/ds-react";
import type { Oppfylt, OppfyltArsaker } from "@/schema/aktivitetskravVurderingSchema";
const getAarsakAvsnitt = (arsak: OppfyltArsaker) => {
  switch (arsak) {
    case "FRISKMELDT":
      return "NAV vurderer at du oppfyller aktivitetsplikten siden du er friskmeldt.";
    case "GRADERT":
      return "NAV vurderer at du oppfyller aktivitetsplikten siden du er i gradert arbeid.";
    case "TILTAK":
      return "NAV vurderer at du oppfyller aktivitetsplikten siden du er i tiltak.";
  }
};
interface Props {
  vurdering: Oppfylt;
}
export const VurderingOppfylt = t0 => {
  const $ = _c(4);
  const {
    vurdering
  } = t0;
  let t1;
  if ($[0] !== vurdering.arsaker[0]) {
    t1 = getAarsakAvsnitt(vurdering.arsaker[0]);
    $[0] = vurdering.arsaker[0];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <BodyLong>{t1}</BodyLong>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};